import React, { useEffect } from 'react';
import './reviews.css';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import ReviewsHeader from "../../components/PagesHeaders/ReviewsHeader/ReviewsHeader";
import { getReviewsSagaAction } from "../../redux/sagaActions";
import Pagination from "../../components/Pagination/Pagination";

const Reviews = () => {
    const dispatch = useDispatch();

    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const reviews = useSelector(state => state.reviews);

    // Функция смены страницы
    const changePage = page => {
        dispatch(getReviewsSagaAction({
            date_from: reviews.date_from,
            date_to: reviews.date_to,
            page
        }));
    };

    useEffect(() => {
        if (!currentEstablishment) return;
        // Получение статистики
        dispatch(getReviewsSagaAction());
    }, [currentEstablishment]);

    return (
        <>
            <Header
                component={ <ReviewsHeader/> }
            />
            <div className="page">
                <div className="page__content">
                    <div className="table__header">
                        <div className="table__count">{ `Всего отзывов: ${ reviews.total_count }` }</div>
                        <div className="table__caption">Отзывы</div>
                    </div>
                    <div className="table">
                        <div className="table__row table__row--header table__row--reviews">
                            <div className="table__cell">Тренер</div>
                            <div className="table__cell">Занятие</div>
                            <div className="table__cell">Оценка</div>
                            <div className="table__cell">Дата и время</div>
                            <div className="table__cell">Посетитель</div>
                            <div className="table__cell">О тренере</div>
                            <div className="table__cell">Предложения</div>
                        </div>
                        {
                            reviews.reviews.map(elem => {
                                return (
                                    <div className="table__row table__row--reviews" key={ elem.id }>
                                        <div className="table__cell">{ elem.coach_name }</div>
                                        <div className="table__cell">{ elem.type_name }</div>
                                        <div className="table__cell">{ elem.rating }</div>
                                        <div className="table__cell">{ elem.datetime }</div>
                                        <div className="table__cell">{ elem.user_name }</div>
                                        <div className="table__cell table__cell--left table__cell--no-overflow">{ elem.coach_review }</div>
                                        <div className="table__cell table__cell--left table__cell--no-overflow">{ elem.other_review }</div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <Pagination handler={ changePage }/>
            </div>
        </>
    );
};

export default Reviews;